<template>
  <div class="vimeo-video">
    <div class="vimeo-container" @click="openVideo">
      <div class="vimeo-thumbnail-container">
        <img class="vimeo-thumbnail" :src="thumbnail" />
      </div>
      <div class="vimeo-title-container">
        <div class="vimeo-title">{{ title }}</div>
      </div>
    </div>
    <b-modal v-model="isModalActive">
      <div class="modal-container">
        <h4 class="modal-title">{{ title }}</h4>
        <div v-html="embedHtml"></div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { VimeoAPI } from "../../services/api";

export default {
  name: "VimeoVideo",
  props: ["videoId"],
  data() {
    return {
      thumbnail: "",
      title: "",
      embedHtml: "",
      isModalActive: false,
    };
  },
  methods: {
    openVideo() {
      this.isModalActive = true;
    },
  },
  created() {
    VimeoAPI.getVideo(this.videoId).then((videoInfo) => {
      this.thumbnail = videoInfo.thumbnail_url;
      this.title = videoInfo.title;
      this.embedHtml = videoInfo.html;
    });
  },
};
</script>
<style scoped>
.vimeo-video {
  display: flex;
  flex-direction: column;
}
.vimeo-title-container {
  text-align: center;
  background-color: black;
  color: white;
  padding: 5px 10px;
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.vimeo-title {
  height: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.vimeo-thumbnail {
  width: 100%;
  vertical-align: middle;
}
.modal >>> .modal-content {
  max-width: 864px !important;
  margin: 0;
}
.modal-title {
  font-size: 20px;
  color: #ffffff;
  padding-bottom: 16px;
}
</style>
